import { useAuthBearerFetch } from "matsuri-hooks"
import dayjs from "dayjs"
import { Shift } from "../model/shift"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

export const useShift = (
    token: string,
    start: dayjs.Dayjs,
    end: dayjs.Dayjs
) => {
    const endpoints = m2mCleaning_cleanerV3.listShifts

    return useAuthBearerFetch<Shift[]>(token, endpoints(), {
        body: JSON.stringify({
            start: start.unix(),
            end: end.unix()
        }),
        method: endpoints.method
    })
}
